export const NumberUtil = {

    /**
     * Formatiert eine Zahl (12000000) nach Schweizer Standard (12'000'000).
     */
    formatCHF(value, decimals = 0) {
        if (value === null || value === undefined || value === "") return "";

        const num = parseFloat(value);
        if (isNaN(num)) return value;

        return new Intl.NumberFormat('de-CH', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }).format(num);
    },

};